import { hashHistory   } from 'react-router'; 
import { resourceApi } from '../utils/fetchUtil';
import * as types from '../constants/actionTypes';
import cookie from 'cookie-machine';
import { logUserSearch } from '../actions/logActions';
import { fireInAppBrowserPlugin } from '../actions/environmentActions'

export const receiveSearchList = (list) => {
  return {
    type: types.RECEIVE_SEARCH_LIST,
    list
  }
}

export const receiveSearchResults = (results) => {
  return {
    type: types.RECIEVE_RESULTS,
    results
  }
}

export const selectMessage = (rowIndex) => {
  return {
    type: types.SELECT_MESSAGE,
    rowIndex
  }
}

export const selectShoppableCptRecord = (shoppableCPTCodeCombinedPricingID) => {

  return {
    type: types.SELECT_SHOPPABLE,
    shoppableCPTCodeCombinedPricingID
  }
}


export const selectSearchTerm = (sctp, searchTerm) => {

  return {
    type: types.SELECT_SEARCH_TERM,
    searchTerm
  }
}

export const setCost = (cost) => {
  return {
    type: types.SET_COST,
    cost
  }
}

export const handleCategorySelect = (categoryId) => {
  return {
    type: types.HANDLE_CATEGORY_SELECT,
    categoryId
  }
}


export function loadSearchList(){

    return dispatch  => {

        let config = {
            method: 'get',
            url: `shop/searchlist`
        };


      resourceApi(config, dispatch)
        .then(function (response) {
            //dispatch(receiveSearchList(response));
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}


export function search(sctp, term) {

    return (dispatch) => {
      
        dispatch(selectSearchTerm(sctp, term));

        //dispatch(logUserSearch(sctp, term));

        //dispatch(loadResults(sctp, term));
    }
}


export function getDirections(dest, origin) {  
  fireInAppBrowserPlugin(`https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${dest}`);
}

export function openMap(address) {  
  fireInAppBrowserPlugin("https://www.google.com/maps/@?api=1&map_action=map&" + address);
}



export function loadResults(sctp, term) {
    return (dispatch) => {

      var lat = cookie.get("latitude");
      var lng = cookie.get("longitude");

      let config = {
          method: 'POST',
          url: `shop/prices`,
          data: {
              ShoppableCPTCodeID: sctp,
              Latitude: lat,
              Longitude: lng
          }
      };
      
      localStorage.setItem( 'term', term);

      hashHistory.push(`/search/${sctp}`);

      dispatch(selectSearchTerm(sctp, term));
      dispatch(logUserSearch(sctp, term));

      resourceApi(config, dispatch)
      .then(function (response) {
          
          console.log(response);
          
          dispatch(receiveSearchResults(response.data));

          

      })
      .catch(function (error) {
          console.log(error);
      });
   }
}



// Calls the API to get a token and
// dispatches actions along the way
export function loadFacility(facilityId, distance) {  
  
 
  return dispatch => {
    
    let config = {
      method: 'get',
      url: `facility/${facilityId}`
    };

      resourceApi(config, dispatch)
        .then(function (response) {
            console.log(response);

            dispatch(recieveFacility(response.data));

            hashHistory.push(`/shop/details/${facilityId}/view/${distance}`);
            //this.props.router.push(`/shop/details/${facilityId}/view/${distance}`);
        })
        .catch(function (error) {
            console.log(error);
            //dispatch(facilityError(error))
            //self.setState({fetchingProvider: false});
        });


  }
}

// export function logUserSearch(sctp, term) {

//     return (dispatch, getState) => {
      
//         const { thisApp } = getState();

//         resourceApi(`log/usersearch/${thisApp.auth.member.ClientUserID}/${term}/${sctp}`, {}, dispatch, false)
//           .then(function (response) {
//               console.log(response);
//           })
//           .catch(function (error) {
//               console.log(error);
//           });
//     }
// }




//FACILITY_REQUEST


export function recieveFacility(facility) {  
  
  return {
    type: types.RECIEVE_FACILITY,
    facility: facility
  }
  
}
export function facilityError(error) {  
  
  return {
    type: types.FACILITY_ERROR,
    errorMessage: error
  }
  
}


// WEBPACK FOOTER //
// ./src/actions/shopActions.js